import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { Home } from './pages/Home';
import { Gallery } from './pages/Gallery';
import { About } from './pages/About';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Contact } from './pages/Contact';
import { Toolkits } from './pages/Toolkits';
import { NetworkingGuide } from './pages/NetworkingGuide';
import { FAQ } from './pages/FAQ';
import { Partners } from './pages/Partners';
import { Events } from './pages/Events';
import { SuccessStories } from './pages/SuccessStories';
import { PartnerWithUs } from './pages/PartnerWithUs';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { CookiePolicy } from './pages/CookiePolicy';
import { Portfolio } from './pages/Portfolio';
import { Membership } from './pages/Membership';
import { JoinTeam } from './pages/JoinTeam';
import { JoinNow } from './pages/JoinNow';
import { InnerCircle } from './pages/InnerCircle';
import { LifetimePartner } from './pages/LifetimePartner';
import { WaitingRoom } from './pages/WaitingRoom';
import { WarriEvent2025 } from './pages/WarriEvent2025';
import { HowToEngage } from './pages/HowToEngage';
import { HostSalon } from './pages/HostSalon';
import { Spotlight } from './pages/Spotlight';
import { BibiEnejeSpotlight } from './pages/BibiEnejeSpotlight';
import { AugustineSpotlight } from './pages/AugustineSpotlight';
import { DrOsagieSpotlight } from './pages/DrOsagieSpotlight';
import { SalonSpotlight } from './pages/SalonSpotlight';
import { Team } from './pages/Team';
import { TeamMemberDetail } from './pages/TeamMemberDetail';
import { AIPowerBundle } from './pages/AIPowerBundle';
import { AIMasterclass } from './pages/AIMasterclass';
import { AIFormTest } from './pages/AIFormTest';
import { AIKids } from './pages/AIKids';
import { KidsAIProgram } from './pages/KidsAIProgram';
import { Dialog } from './components/UI/Dialog';
import { HostSalonDialog } from './components/UI/HostSalonDialog';
import { PaymentDialog } from './components/UI/PaymentDialog';
import { CorporateTrainingDialog } from './components/UI/CorporateTrainingDialog';
import './index.css';
// ScrollToTop component that scrolls to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isHostFormOpen, setIsHostFormOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isCorporateTrainingOpen, setIsCorporateTrainingOpen] = useState(false);
  const openRegistrationForm = () => {
    setIsFormOpen(true);
  };
  const openHostSalonForm = () => {
    setIsHostFormOpen(true);
  };
  const openPaymentForm = () => {
    setIsPaymentOpen(true);
  };
  const openCorporateTrainingForm = () => {
    setIsCorporateTrainingOpen(true);
  };
  useEffect(() => {
    window.openRegistrationForm = openRegistrationForm;
    window.openHostSalonForm = openHostSalonForm;
    window.openPaymentForm = openPaymentForm;
    window.openCorporateTrainingForm = openCorporateTrainingForm;
    return () => {
      delete window.openRegistrationForm;
      delete window.openHostSalonForm;
      delete window.openPaymentForm;
      delete window.openCorporateTrainingForm;
    };
  }, []);
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Layout openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} data-id="element-5" />} data-id="element-4" />
          <Route path="/gallery" element={<Gallery data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
          <Route path="/team" element={<Team data-id="element-11" />} data-id="element-10" />
          <Route path="/team/:id" element={<TeamMemberDetail data-id="element-13" />} data-id="element-12" />
          <Route path="/blog" element={<Blog data-id="element-15" />} data-id="element-14" />
          <Route path="/blog/:slug" element={<BlogPost data-id="element-17" />} data-id="element-16" />
          <Route path="/contact" element={<Contact data-id="element-19" />} data-id="element-18" />
          <Route path="/toolkits" element={<Toolkits data-id="element-21" />} data-id="element-20" />
          <Route path="/networking-guide" element={<NetworkingGuide data-id="element-23" />} data-id="element-22" />
          <Route path="/faq" element={<FAQ openRegistrationForm={openRegistrationForm} data-id="element-25" />} data-id="element-24" />
          <Route path="/partners" element={<Partners data-id="element-27" />} data-id="element-26" />
          <Route path="/events" element={<Events data-id="element-29" />} data-id="element-28" />
          <Route path="/events/warri-2025" element={<WarriEvent2025 data-id="element-31" />} data-id="element-30" />
          <Route path="/success-stories" element={<SuccessStories data-id="element-33" />} data-id="element-32" />
          <Route path="/portfolio" element={<Portfolio data-id="element-35" />} data-id="element-34" />
          <Route path="/membership" element={<Membership data-id="element-37" />} data-id="element-36" />
          <Route path="/join-team" element={<JoinTeam data-id="element-39" />} data-id="element-38" />
          <Route path="/joinnow" element={<JoinNow data-id="element-41" />} data-id="element-40" />
          <Route path="/inner-circle" element={<InnerCircle data-id="element-43" />} data-id="element-42" />
          <Route path="/lifetime-partner" element={<LifetimePartner data-id="element-45" />} data-id="element-44" />
          <Route path="/waiting-room" element={<WaitingRoom data-id="element-47" />} data-id="element-46" />
          <Route path="/join-the-salon" element={<HowToEngage data-id="element-49" />} data-id="element-48" />
          <Route path="/host-salon" element={<HostSalon data-id="element-51" />} data-id="element-50" />
          <Route path="/spotlight" element={<Spotlight data-id="element-53" />} data-id="element-52" />
          <Route path="/salon-spotlight" element={<SalonSpotlight data-id="element-55" />} data-id="element-54" />
          <Route path="/spotlight/bibi-eneje" element={<BibiEnejeSpotlight data-id="element-57" />} data-id="element-56" />
          <Route path="/spotlight/augustine-aigbokhaevbo" element={<AugustineSpotlight data-id="element-59" />} data-id="element-58" />
          <Route path="/spotlight/dr-osagie-alex" element={<DrOsagieSpotlight data-id="element-61" />} data-id="element-60" />
          <Route path="/partner-with-us" element={<PartnerWithUs openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} data-id="element-63" />} data-id="element-62" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-65" />} data-id="element-64" />
          <Route path="/terms-of-service" element={<TermsOfService data-id="element-67" />} data-id="element-66" />
          <Route path="/cookie-policy" element={<CookiePolicy data-id="element-69" />} data-id="element-68" />
          <Route path="/ai-power-bundle" element={<AIPowerBundle data-id="element-71" />} data-id="element-70" />
          <Route path="/ai-masterclass" element={<AIMasterclass data-id="element-73" />} data-id="element-72" />
          <Route path="/ai-form-test" element={<AIFormTest data-id="element-75" />} data-id="element-74" />
          <Route path="/ai-kids" element={<AIKids data-id="element-77" />} data-id="element-76" />
          <Route path="/kids-ai-program" element={<KidsAIProgram data-id="element-79" />} data-id="element-78" />
        </Routes>
      </Layout>
      <Dialog isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} title="Join the Salon" size="xl" data-id="element-80">
        <div className="w-full" data-id="element-81">
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdr_5jvYO4hJncEC0hjHQweFJSh8FFpzrBhsjQvCQemuZT7MA/viewform?embedded=true" width="100%" height="600" frameBorder="0" marginHeight={0} marginWidth={0} data-id="element-82">
            Loading…
          </iframe>
        </div>
      </Dialog>
      <HostSalonDialog isOpen={isHostFormOpen} onClose={() => setIsHostFormOpen(false)} data-id="element-83" />
      <PaymentDialog isOpen={isPaymentOpen} onClose={() => setIsPaymentOpen(false)} data-id="element-84" />
      <CorporateTrainingDialog isOpen={isCorporateTrainingOpen} onClose={() => setIsCorporateTrainingOpen(false)} data-id="element-85" />
    </Router>;
}